// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PTViaNotReference } from './PTViaNotReference';
import {
    PTViaNotReferenceFromJSON,
    PTViaNotReferenceFromJSONTyped,
    PTViaNotReferenceToJSON,
    PTViaNotReferenceToJSONTyped,
} from './PTViaNotReference';
import type { RealtimeModeEnum } from './RealtimeModeEnum';
import {
    RealtimeModeEnumFromJSON,
    RealtimeModeEnumFromJSONTyped,
    RealtimeModeEnumToJSON,
    RealtimeModeEnumToJSONTyped,
} from './RealtimeModeEnum';
import type { PTViaReference } from './PTViaReference';
import {
    PTViaReferenceFromJSON,
    PTViaReferenceFromJSONTyped,
    PTViaReferenceToJSON,
    PTViaReferenceToJSONTyped,
} from './PTViaReference';
import type { NoticeAttributeEnum } from './NoticeAttributeEnum';
import {
    NoticeAttributeEnumFromJSON,
    NoticeAttributeEnumFromJSONTyped,
    NoticeAttributeEnumToJSON,
    NoticeAttributeEnumToJSONTyped,
} from './NoticeAttributeEnum';
import type { AlternateMatchEnum } from './AlternateMatchEnum';
import {
    AlternateMatchEnumFromJSON,
    AlternateMatchEnumFromJSONTyped,
    AlternateMatchEnumToJSON,
    AlternateMatchEnumToJSONTyped,
} from './AlternateMatchEnum';
import type { TrainStopAssignmentsEnum } from './TrainStopAssignmentsEnum';
import {
    TrainStopAssignmentsEnumFromJSON,
    TrainStopAssignmentsEnumFromJSONTyped,
    TrainStopAssignmentsEnumToJSON,
    TrainStopAssignmentsEnumToJSONTyped,
} from './TrainStopAssignmentsEnum';
import type { OptimisationMethod } from './OptimisationMethod';
import {
    OptimisationMethodFromJSON,
    OptimisationMethodFromJSONTyped,
    OptimisationMethodToJSON,
    OptimisationMethodToJSONTyped,
} from './OptimisationMethod';
import type { TransportModeEnum } from './TransportModeEnum';
import {
    TransportModeEnumFromJSON,
    TransportModeEnumFromJSONTyped,
    TransportModeEnumToJSON,
    TransportModeEnumToJSONTyped,
} from './TransportModeEnum';
import type { TripMobilityFilter } from './TripMobilityFilter';
import {
    TripMobilityFilterFromJSON,
    TripMobilityFilterFromJSONTyped,
    TripMobilityFilterToJSON,
    TripMobilityFilterToJSONTyped,
} from './TripMobilityFilter';
import type { NonPTTripEnum } from './NonPTTripEnum';
import {
    NonPTTripEnumFromJSON,
    NonPTTripEnumFromJSONTyped,
    NonPTTripEnumToJSON,
    NonPTTripEnumToJSONTyped,
} from './NonPTTripEnum';
import type { OccupancyAverageEnum } from './OccupancyAverageEnum';
import {
    OccupancyAverageEnumFromJSON,
    OccupancyAverageEnumFromJSONTyped,
    OccupancyAverageEnumToJSON,
    OccupancyAverageEnumToJSONTyped,
} from './OccupancyAverageEnum';
import type { PTViaNoChangeAtReference } from './PTViaNoChangeAtReference';
import {
    PTViaNoChangeAtReferenceFromJSON,
    PTViaNoChangeAtReferenceFromJSONTyped,
    PTViaNoChangeAtReferenceToJSON,
    PTViaNoChangeAtReferenceToJSONTyped,
} from './PTViaNoChangeAtReference';
import type { AccessibilityEnum } from './AccessibilityEnum';
import {
    AccessibilityEnumFromJSON,
    AccessibilityEnumFromJSONTyped,
    AccessibilityEnumToJSON,
    AccessibilityEnumToJSONTyped,
} from './AccessibilityEnum';
import type { DatedVehicleJourneyReference } from './DatedVehicleJourneyReference';
import {
    DatedVehicleJourneyReferenceFromJSON,
    DatedVehicleJourneyReferenceFromJSONTyped,
    DatedVehicleJourneyReferenceToJSON,
    DatedVehicleJourneyReferenceToJSONTyped,
} from './DatedVehicleJourneyReference';

/**
 * {Idempotent: GET with body payload} RequestBody containing search filter params.
 * @export
 * @interface TripsByOriginAndDestinationRequestBody
 */
export interface TripsByOriginAndDestinationRequestBody {
    /**
     * Starting point of the trip at origin (departure). See v3 **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    origin: string;
    /**
     * Ending point of the trip at destination (arrival). See **PlaceReference** in [complex parameter](https://github.com/SchweizerischeBundesbahnen/journey-service/blob/master/v3/JSON-Objects.md)
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    destination: string;
    /**
     * Tolerated walk distance (radius [m]) at `Place` origin (departure). Default is 1500
     * @type {number}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    originRadius?: number;
    /**
     * Tolerated walk distance (radius [m]) at `Place` destination (arrival). Default is 1500
     * @type {number}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    destinationRadius?: number;
    /**
     * Search for arriving (true) or departing (false) trips.
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    forArrival?: boolean;
    /**
     * (Local) date at either origin (`forArrival`=false) or destination (`forArrival`=true) related to `time`, defaults to TODAY.
     * @type {Date}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    date?: Date;
    /**
     * Local time at either origin (`forArrival`=false) or destination (`forArrival`=true) related to `date`, defaults to NOW (seconds will be ignored).
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    time?: string;
    /**
     * 
     * @type {OccupancyAverageEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    occupancyAverage?: OccupancyAverageEnum;
    /**
     * 
     * @type {TripMobilityFilter}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    mobilityFilter?: TripMobilityFilter;
    /**
     * 
     * @type {Array<PTViaReference>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    vias?: Array<PTViaReference>;
    /**
     * 
     * @type {Array<PTViaNotReference>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    viasNot?: Array<PTViaNotReference>;
    /**
     * 
     * @type {Array<PTViaNoChangeAtReference>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    viasNoTransfer?: Array<PTViaNoChangeAtReference>;
    /**
     * 
     * @type {RealtimeModeEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    realtimeMode?: RealtimeModeEnum;
    /**
     * Based on a returned `TripResponse::pagingCursor`, `previous` or `next` connections **reusing the very same search-parameters** can be retrieved by scrolling pagination mechanism, see `Trip::pagingChecksum`).
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    pagingCursor?: string;
    /**
     * 
     * @type {OptimisationMethod}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    optimisationMethod?: OptimisationMethod;
    /**
     * 
     * @type {AccessibilityEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeAccessibility?: AccessibilityEnum;
    /**
     * 
     * @type {AlternateMatchEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeAlternateMatch?: AlternateMatchEnum;
    /**
     * 
     * @type {Set<NoticeAttributeEnum>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeNoticeAttributes?: Set<NoticeAttributeEnum>;
    /**
     * Consider additional connections by Bus or S-Bahn leading to destination as well (de:'Zusätzliche Alternativverbindungen', 'Mehrdimensionale Suche', 'Preiswerte Suche').<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeEconomic?: boolean;
    /**
     * Consider alternative stations origin/destination (de: Erweiterte Anzeige).
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeUnsharp?: boolean;
    /**
     * Consider earlier leaving connections, even if arrival is later.
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeEarlier?: boolean;
    /**
     * Create Trip::EcoBalance (C02, ..) per Trip. DEFAULT is based on SBB default car eco-params.<br>x-extensible-enum: 
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeEcologyComparison?: TripsByOriginAndDestinationRequestBodyIncludeEcologyComparisonEnum;
    /**
     * 
     * @type {Set<TransportModeEnum>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeTransportModes?: Set<TransportModeEnum>;
    /**
     * `Trip::operatingPeriods` will always be returned if it is a **repeatable planned Trip over the period**. To enforce concrete planned dates in `OperatingPeriod::operatingDays`set `includeOperatingDays=true` (PTRideLeg::serviceJourney::operationPeriods will remain empty, because whole Trip is of interest).<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeOperatingDays?: boolean;
    /**
     * With or without a plottable polyline for each vehicle-journey (if available).<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeRouteProjection?: boolean;
    /**
     * Relates to `PTRideLeg::groupReservationStatus`. Include the status for group-reservation possibilities (source CAPRE).<br>Format 'x:y' which means to check reservation status for number of x passenger in first class and y passengers in second class.<br>This filter **needs special Grants for a clientId**, if you observe **403 FORRBIDDEN, please ajdust.**<br>This parameter has an impact on performance and/or response volume, set wisely! `ServiceJourney::notices` will get an entry of `type=INFO, key=RN` if available, its `Notice::value` is relevant for Postauto AG (PAG) operations-reference.
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeGroupReservation?: string;
    /**
     * Create some summary facts about each Trip (useful for UI overviews).<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeSummary?: boolean;
    /**
     * Whether the `PTRideLeg's` should include intermediate stops (between the passenger's board and alight in `ServiceJourney::stopPoints`).<br>x-extensible-enum:  [ALL,NONE,BOARDING_ALIGHTING] where ALL is BOARDING_ALIGHTING plus virtual stops.
     * @type {string}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeIntermediateStops?: TripsByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum;
    /**
     * 
     * @type {TrainStopAssignmentsEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeTrainStopAssignments?: TrainStopAssignmentsEnum;
    /**
     * If set pack this object (more or less) into `Trip::id` to recover search-parameters in post.<br>This parameter has an impact on performance and/or response volume, set wisely!
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeRequestArguments?: boolean;
    /**
     * 
     * @type {NonPTTripEnum}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    includeNonPublicTransportationTrips?: NonPTTripEnum;
    /**
     * 
     * @type {Array<DatedVehicleJourneyReference>}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    excludeDatedVehicleJourneys?: Array<DatedVehicleJourneyReference>;
    /**
     * In case of `StopPlace` to `StopPlace` at origin and/or destination set true to prevent `AccessLeg's` at beginning or end.
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    excludeFootpathAtOriginAndDestination?: boolean;
    /**
     * Due to rare national/international routing implications in rare cases lead to non-necessary transfer's between 2 `PTRideLeg's` (if set false marked with a `Notice::name`="hi" 'remain seated'). Setting this filter to true, merges these 2 `PTRideLeg's` into one (only recommended for enduser channels like sbb.ch to simplify `Trip::legs`representation.)
     * @type {boolean}
     * @memberof TripsByOriginAndDestinationRequestBody
     */
    excludeUnnecessaryTransfers?: boolean;
}


/**
 * @export
 */
export const TripsByOriginAndDestinationRequestBodyIncludeEcologyComparisonEnum = {
    None: 'NONE',
    Default: 'DEFAULT'
} as const;
export type TripsByOriginAndDestinationRequestBodyIncludeEcologyComparisonEnum = typeof TripsByOriginAndDestinationRequestBodyIncludeEcologyComparisonEnum[keyof typeof TripsByOriginAndDestinationRequestBodyIncludeEcologyComparisonEnum];

/**
 * @export
 */
export const TripsByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum = {
    All: 'ALL',
    BoardingAlighting: 'BOARDING_ALIGHTING',
    None: 'NONE'
} as const;
export type TripsByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum = typeof TripsByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum[keyof typeof TripsByOriginAndDestinationRequestBodyIncludeIntermediateStopsEnum];


/**
 * Check if a given object implements the TripsByOriginAndDestinationRequestBody interface.
 */
export function instanceOfTripsByOriginAndDestinationRequestBody(value: object): value is TripsByOriginAndDestinationRequestBody {
    if (!('origin' in value) || value['origin'] === undefined) return false;
    if (!('destination' in value) || value['destination'] === undefined) return false;
    return true;
}

export function TripsByOriginAndDestinationRequestBodyFromJSON(json: any): TripsByOriginAndDestinationRequestBody {
    return TripsByOriginAndDestinationRequestBodyFromJSONTyped(json, false);
}

export function TripsByOriginAndDestinationRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TripsByOriginAndDestinationRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'origin': json['origin'],
        'destination': json['destination'],
        'originRadius': json['originRadius'] == null ? undefined : json['originRadius'],
        'destinationRadius': json['destinationRadius'] == null ? undefined : json['destinationRadius'],
        'forArrival': json['forArrival'] == null ? undefined : json['forArrival'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'time': json['time'] == null ? undefined : json['time'],
        'occupancyAverage': json['occupancyAverage'] == null ? undefined : OccupancyAverageEnumFromJSON(json['occupancyAverage']),
        'mobilityFilter': json['mobilityFilter'] == null ? undefined : TripMobilityFilterFromJSON(json['mobilityFilter']),
        'vias': json['vias'] == null ? undefined : ((json['vias'] as Array<any>).map(PTViaReferenceFromJSON)),
        'viasNot': json['viasNot'] == null ? undefined : ((json['viasNot'] as Array<any>).map(PTViaNotReferenceFromJSON)),
        'viasNoTransfer': json['viasNoTransfer'] == null ? undefined : ((json['viasNoTransfer'] as Array<any>).map(PTViaNoChangeAtReferenceFromJSON)),
        'realtimeMode': json['realtimeMode'] == null ? undefined : RealtimeModeEnumFromJSON(json['realtimeMode']),
        'pagingCursor': json['pagingCursor'] == null ? undefined : json['pagingCursor'],
        'optimisationMethod': json['optimisationMethod'] == null ? undefined : OptimisationMethodFromJSON(json['optimisationMethod']),
        'includeAccessibility': json['includeAccessibility'] == null ? undefined : AccessibilityEnumFromJSON(json['includeAccessibility']),
        'includeAlternateMatch': json['includeAlternateMatch'] == null ? undefined : AlternateMatchEnumFromJSON(json['includeAlternateMatch']),
        'includeNoticeAttributes': json['includeNoticeAttributes'] == null ? undefined : (new Set((json['includeNoticeAttributes'] as Array<any>).map(NoticeAttributeEnumFromJSON))),
        'includeEconomic': json['includeEconomic'] == null ? undefined : json['includeEconomic'],
        'includeUnsharp': json['includeUnsharp'] == null ? undefined : json['includeUnsharp'],
        'includeEarlier': json['includeEarlier'] == null ? undefined : json['includeEarlier'],
        'includeEcologyComparison': json['includeEcologyComparison'] == null ? undefined : json['includeEcologyComparison'],
        'includeTransportModes': json['includeTransportModes'] == null ? undefined : (new Set((json['includeTransportModes'] as Array<any>).map(TransportModeEnumFromJSON))),
        'includeOperatingDays': json['includeOperatingDays'] == null ? undefined : json['includeOperatingDays'],
        'includeRouteProjection': json['includeRouteProjection'] == null ? undefined : json['includeRouteProjection'],
        'includeGroupReservation': json['includeGroupReservation'] == null ? undefined : json['includeGroupReservation'],
        'includeSummary': json['includeSummary'] == null ? undefined : json['includeSummary'],
        'includeIntermediateStops': json['includeIntermediateStops'] == null ? undefined : json['includeIntermediateStops'],
        'includeTrainStopAssignments': json['includeTrainStopAssignments'] == null ? undefined : TrainStopAssignmentsEnumFromJSON(json['includeTrainStopAssignments']),
        'includeRequestArguments': json['includeRequestArguments'] == null ? undefined : json['includeRequestArguments'],
        'includeNonPublicTransportationTrips': json['includeNonPublicTransportationTrips'] == null ? undefined : NonPTTripEnumFromJSON(json['includeNonPublicTransportationTrips']),
        'excludeDatedVehicleJourneys': json['excludeDatedVehicleJourneys'] == null ? undefined : ((json['excludeDatedVehicleJourneys'] as Array<any>).map(DatedVehicleJourneyReferenceFromJSON)),
        'excludeFootpathAtOriginAndDestination': json['excludeFootpathAtOriginAndDestination'] == null ? undefined : json['excludeFootpathAtOriginAndDestination'],
        'excludeUnnecessaryTransfers': json['excludeUnnecessaryTransfers'] == null ? undefined : json['excludeUnnecessaryTransfers'],
    };
}

  export function TripsByOriginAndDestinationRequestBodyToJSON(json: any): TripsByOriginAndDestinationRequestBody {
      return TripsByOriginAndDestinationRequestBodyToJSONTyped(json, false);
  }

  export function TripsByOriginAndDestinationRequestBodyToJSONTyped(value?: TripsByOriginAndDestinationRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'origin': value['origin'],
        'destination': value['destination'],
        'originRadius': value['originRadius'],
        'destinationRadius': value['destinationRadius'],
        'forArrival': value['forArrival'],
        'date': value['date'] == null ? undefined : ((value['date']).toISOString().substring(0,10)),
        'time': value['time'],
        'occupancyAverage': OccupancyAverageEnumToJSON(value['occupancyAverage']),
        'mobilityFilter': TripMobilityFilterToJSON(value['mobilityFilter']),
        'vias': value['vias'] == null ? undefined : ((value['vias'] as Array<any>).map(PTViaReferenceToJSON)),
        'viasNot': value['viasNot'] == null ? undefined : ((value['viasNot'] as Array<any>).map(PTViaNotReferenceToJSON)),
        'viasNoTransfer': value['viasNoTransfer'] == null ? undefined : ((value['viasNoTransfer'] as Array<any>).map(PTViaNoChangeAtReferenceToJSON)),
        'realtimeMode': RealtimeModeEnumToJSON(value['realtimeMode']),
        'pagingCursor': value['pagingCursor'],
        'optimisationMethod': OptimisationMethodToJSON(value['optimisationMethod']),
        'includeAccessibility': AccessibilityEnumToJSON(value['includeAccessibility']),
        'includeAlternateMatch': AlternateMatchEnumToJSON(value['includeAlternateMatch']),
        'includeNoticeAttributes': value['includeNoticeAttributes'] == null ? undefined : (Array.from(value['includeNoticeAttributes'] as Set<any>).map(NoticeAttributeEnumToJSON)),
        'includeEconomic': value['includeEconomic'],
        'includeUnsharp': value['includeUnsharp'],
        'includeEarlier': value['includeEarlier'],
        'includeEcologyComparison': value['includeEcologyComparison'],
        'includeTransportModes': value['includeTransportModes'] == null ? undefined : (Array.from(value['includeTransportModes'] as Set<any>).map(TransportModeEnumToJSON)),
        'includeOperatingDays': value['includeOperatingDays'],
        'includeRouteProjection': value['includeRouteProjection'],
        'includeGroupReservation': value['includeGroupReservation'],
        'includeSummary': value['includeSummary'],
        'includeIntermediateStops': value['includeIntermediateStops'],
        'includeTrainStopAssignments': TrainStopAssignmentsEnumToJSON(value['includeTrainStopAssignments']),
        'includeRequestArguments': value['includeRequestArguments'],
        'includeNonPublicTransportationTrips': NonPTTripEnumToJSON(value['includeNonPublicTransportationTrips']),
        'excludeDatedVehicleJourneys': value['excludeDatedVehicleJourneys'] == null ? undefined : ((value['excludeDatedVehicleJourneys'] as Array<any>).map(DatedVehicleJourneyReferenceToJSON)),
        'excludeFootpathAtOriginAndDestination': value['excludeFootpathAtOriginAndDestination'],
        'excludeUnnecessaryTransfers': value['excludeUnnecessaryTransfers'],
    };
}

